import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import ipss from "../../Assets/Projects/ipss-laptop.png";
import njrise from "../../Assets/Projects/njrise-laptop.png";
import lisa from "../../Assets/Projects/lisa-laptop.png";
import hanj from "../../Assets/Projects/hanj-laptop.png";
import mths from "../../Assets/Projects/mths-laptop.png";
import portf from "../../Assets/Projects/portf-laptop.png";
import lohc from "../../Assets/Projects/lohc-laptop.png";
import svee from "../../Assets/Projects/svee-laptop.png";
import hpac from "../../Assets/Projects/hpac-laptop.png";
import hanjMobile from "../../Assets/Projects/hanj-mobile.png";
import portfMobile from "../../Assets/Projects/portf-mobile.png";
import lisaMobile from "../../Assets/Projects/lisa-mobile.png";
import mthsMobile from "../../Assets/Projects/mths-mobile.png";
import ipssMobile from "../../Assets/Projects/ipss-mobile.png";
import njriseMobile from "../../Assets/Projects/njrise-mobile.png";
import lohcMobile from "../../Assets/Projects/lohc-mobile.png";
import sveeMobile from "../../Assets/Projects/svee-mobile.png";
import hpacMobile from "../../Assets/Projects/hpac-mobile.png";

function Projects() {
  return (
    <Container fluid className="home-section projects-page px-0 py-0" id="projects">
      <Particle />

      {/* INNER CONTENT WRAPPER */}
      <Container className="projects-content">
        <h1 className="project-heading">
          Recent <strong className="teal">Work </strong>
        </h1>

        <p style={{ color: "white", fontSize: 20 }}>
          Here are a few projects I've worked on recently.
        </p>

        <Row
          className="project-grid"
          style={{ justifyContent: "center", paddingBottom: "10px" }}
        >
          
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hpac}
              mobileImg={hpacMobile}
              title="Arts Commission Website"
              date="2026"
              description="A bold redesign of a local non-profit arts commission, built on Wordpress with Elementor"
              demoLink="https://hpartscommission.com/"
       
              caseStudy="I designed and built this site for a local, non-profit arts group who works with the community and collaborates with other local groups to create public art and bring awareness to the town and surrounding areas."
              features={[
                "Interactive polaroid photo gallery with a click-to-open lightbox styled as a polaroid and Post-it note",
                "Scroll-aware navbar that transitions from transparent to solid as the user scrolls",
                "Fully responsive layout, including breakpoint-specific adjustments for image cropping, typography, and content flow",
                "Working contact form using Gravity Forms plugin"
              ]}
              />
              </Col>
          
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={svee}
              mobileImg={sveeMobile}
              title="Local Musician Website"
              date="2026"
              description="A bold, editorial-style website for a New Jersey singer-songwriter, built with React, TailwindCSS, and a custom gig-poster design system."
              demoLink="https://sheilaveemusic.com/"
              ghLink="https://github.com/renee-runyon/svee"
              caseStudy="I designed and built this site for a working musician who performs across five distinct projects. Rather than defaulting to a generic template look, I developed a custom 'gig poster' visual language: a bold condensed display typeface paired with monospace labels, distinct color palette, and a scrolling marquee ticker inspired by venue signage. The centerpiece is an interactive polaroid-style gallery where each project displays as a photo with a handwritten-style caption. Clicking one opens a lightbox styled like a polaroid paired with a post-it note holding project details and social links. I built the site with React and Vite, styled it with TailwindCSS, and integrated a contact form."
              features={[
                "Interactive polaroid photo gallery with a click-to-open lightbox styled as a polaroid and Post-it note",
                "Scrolling marquee ticker component highlighting projects",
                "Scroll-aware navbar that transitions from transparent to solid as the user scrolls",
                "Fully responsive layout, including breakpoint-specific adjustments for image cropping, typography, and content flow",
                "Working contact form with client-side validation, deployed on Vercel for fast load times"
              ]}
              />
              </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ipss}
              mobileImg={ipssMobile}
              title="IPSS"
              date="2025"
              description="Custom WordPress build for a professional training organization, developed from designer-provided mockups with a focus on program structure and secure student access."
              demoLink="https://ipssny.org"
              caseStudy="For IPSS, I collaborated with a professional designer who provided the layouts for the new site. My role was to implement the full build using WordPress and Elementor, create structured program pages, and develop private-access areas for enrolled students. I integrated a secure student portal for class materials, built custom application forms, and organized the overall information architecture to support multiple certification tracks. The result is a polished, modern site that meets the needs of both prospective and active students."
              features={[
                "Pixel-accurate development from designer-provided mockups",
                "Secure student portal for private class materials",
                "Custom application workflows for new student enrollment",
                "Elementor-driven templates with structured program pages",
                "Clear information hierarchy for multiple certification paths",
                "Fully responsive design implementation across all devices",
              ]}
            />


          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={njrise}
              mobileImg={njriseMobile}
              title="NJ Rise"
              date="2023"
              description="Custom WordPress build for a local nonprofit, developed from designer-provided layouts and powered by a WooCommerce-based Virtual Pantry donation system."
              demoLink="https://njrise.org"
              caseStudy="NJ Rise partnered with a professional designer to refresh their visual identity, and my role was to bring those designs to life in a functional, accessible, and mission-driven website. I translated the designer’s layouts into a custom WordPress build using Elementor and implemented a WooCommerce-powered Virtual Pantry that allows donors to contribute by selecting specific items. I also improved content structure, created mobile-optimized templates, and ensured the site works seamlessly for donors, volunteers, and clients."
              features={[
                "Implemented designer-provided layouts with pixel-accurate fidelity",
                "WooCommerce-powered Virtual Pantry donation system",
                "Elementor templating and custom content organization",
                "Improved pathways for donors, volunteers, and clients",
                "Mobile-first templates optimized for easy browsing",
                "Clear, mission-focused content structure",
              ]}
            />


          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={lisa}
              mobileImg={lisaMobile}
              title="Local Artist's Website"
              date="2023"
              description="A modern redesign for a local assemblage artist, built in WordPress + Elementor with a focus on visual storytelling, gallery presentation, and ease of content updates."
              demoLink="https://lisabagwell.com"
              caseStudy="Lisa Bagwell’s work involves intricate assemblage sculptures that deserved a cleaner, more expressive online presence. Her previous site was difficult to navigate and didn’t showcase her artwork effectively. I redesigned the entire site using WordPress and Elementor, creating a bright, minimal layout that highlights her portfolio. I also improved the gallery structure, enhanced mobile responsiveness, and replaced outdated forms with Gravity Forms for a more reliable contact and inquiry experience."
              features={[
                "Clean, artist-friendly redesign focused on visual presentation",
                "Improved gallery structure for sculptures and commissions",
                "Mobile-first layout optimized for artwork browsing",
                "Custom Elementor sections tailored to the artist’s style",
                "Rebuilt contact and inquiry system using Gravity Forms",
              ]}
            />

          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={mths}
              mobileImg={mthsMobile}
              title="Mount Tabor Historical Society"
              date="2026"
              description="A full rebuild of the Mount Tabor Historical Society website using WordPress and Elementor, featuring an interactive walking tour powered by GeoDirectory."
              demoLink="https://mounttabornj.org"
              caseStudy="The Mount Tabor Historical Society needed a modern, easy-to-navigate website that could showcase local history while supporting events, newsletters, tours, and volunteers. I rebuilt the entire site structure in WordPress using Elementor, reorganizing content, modernizing the layout, and creating a more intuitive user experience. A major feature is the fully interactive Walking Tour system powered by GeoDirectory, which supports both in-person and virtual visitors through unique stop pages, media galleries, and QR code signage located throughout the town."
              features={[
                "Custom interactive walking tour using GeoDirectory",
                "QR-code enabled stop pages for in-person visitors",
                "Full site restructure for clarity and ease of use",
                "Elementor-based design system with improved visual hierarchy",
                "Optimized pages for events, newsletters, and membership",
                "Mobile-first experience for tourists and local visitors",
              ]}
            />

          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hanj}
              mobileImg={hanjMobile}
              title="Hands Across NJ"
              date="2025"
              description="A collaborative Next.js build for a statewide volunteer event, using an existing codebase customized and expanded for our specific needs."
              demoLink="https://handsacrossnj.org"
              ghLink="https://github.com/runyonrm04/nj-chain"
              caseStudy="Hands Across NJ was a large, statewide volunteer initiative that required a fast, reliable, mobile-first website to coordinate thousands of participants. I took the lead on implementing and customizing the site using an existing Next.js project as the foundation. My work included restructuring pages, refining layouts, integrating content, styling major sections, optimizing mobile responsiveness, and adapting components to fit the needs of our event. The ZIP-based segment assignment and mapping logic were developed collaboratively with another team member who handled the more advanced geospatial and data-processing features, while I focused on the site build, UI implementation, testing, and deployment."
              features={[
                "Lead developer on site implementation using an existing Next.js codebase",
                "Customized layout, structure, and content for event-specific needs",
                "Integrated and styled interactive map and route components",
                "Collaborative ZIP-to-segment assignment feature (team-built functionality)",
                "Mobile-first UI improvements for volunteers and participants",
                "Vercel optimization, deployment, and ongoing updates",
              ]}
            />


          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={portf}
              mobileImg={portfMobile}
              title="Renee's Portfolio"
              date="2025"
              description="A modern, responsive developer portfolio showcasing my recent work, built with React and customized extensively from an open-source template."
              demoLink="https://renee-portfolio-eight.vercel.app/"
              ghLink="https://github.com/renee-runyon/renee-portfolio"
              caseStudy="This portfolio started as a heavily customized build based on an open-source React template. I rebuilt large sections of the layout, rewrote components, redesigned the visual style, and added new features such as project modals, mobile/desktop mockups, refined card layouts, improved spacing, and a cohesive color system. The goal was to create a lightweight, expressive personal site that highlights my work clearly and looks great on every device."
              features={[
                "Custom project modal system with mobile + desktop mockup overlays",
                "Refined layout spacing, color theme, and typography",
                "Rebuilt components for cleaner structure and better UX",
                "Added micro case studies and feature lists for each project",
                "Improved mobile responsiveness and card sizing consistency",
                "React-Bootstrap integration and UI enhancements",
              ]}
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={lohc}
              mobileImg={lohcMobile}
              title="Personal Blog Site"
              date="2025"
              description="A simple but modern & responsive blog site, built with Next.js and TailwindCSS."
              demoLink="https://littleorangehellcat-dev.vercel.app/"
              ghLink="https://github.com/renee-runyon/littleorangehellcat-dev"
              caseStudy="I built this blog from scratch using Next.js, TailwindCSS, and Vercel, crafting it to be a clean, friendly home for stories, photos, and daily musings about Rudy, the Little Orange Hellcat and friends. I designed and implemented a custom layout with a cohesive color system, responsive navigation, clear typography, and a simple yet expressive aesthetic that feels warm and personal. I built custom components for the core sections — About, Stories, Gallery — and rethought the layout structure to ensure readability, consistency, and ease of use. The goal was to create a lightweight, inviting space that focuses on content: the stories, the images, and the personality behind the site. I also optimized for mobile and desktop to make sure the experience feels good across devices."

              features={[
              "Custom React-based layout with clean, minimalist styling",
              "Dedicated About / Stories / Gallery sections for structured content",
              "Responsive design with thoughtful typography and spacing for readability",
              "Cohesive color theme and visual identity aligned with the blog’s cozy, personal vibe",
              "Custom components for posts and galleries for simplicity and reusability",
              "Lightweight build deployed to Vercel for fast load times and smooth performance"
            ]}
          />
        </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
